import { render } from "./Biografia.vue?vue&type=template&id=7aebd9ee&scoped=true"
const script = {}

import "./Biografia.vue?vue&type=style&index=0&id=7aebd9ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7aebd9ee"

export default script